(function () {
  function initialize(scope) {
    scope.querySelectorAll('[data-featured-blog-tag-section]').forEach(function (section) {
      if (section.dataset.tagLoaderInitialized === 'true') return;

      var tag = section.dataset.blogTag;
      var blogUrl = section.dataset.blogUrl;
      var items = section.querySelector('[data-featured-blog-items]');
      var limit = parseInt(section.dataset.postLimit, 10) || 3;

      if (!items || !blogUrl || !tag || tag === 'all') return;

      section.dataset.tagLoaderInitialized = 'true';
      items.setAttribute('aria-busy', 'true');

      loadTaggedCards(blogUrl, tag, limit)
        .then(function (cards) {
          if (cards.length) {
            items.replaceChildren.apply(items, cards.slice(0, limit));
          }
        })
        .catch(function () {
          // Keep the Liquid-rendered fallback if the tagged page can't be loaded.
        })
        .finally(function () {
          items.removeAttribute('aria-busy');
        });
    });
  }

  async function loadTaggedCards(blogUrl, tag, limit) {
    var cards = [];
    var seenArticles = new Set();

    for (var page = 1; page <= 3 && cards.length < limit; page += 1) {
      var taggedUrl = new URL(
        blogUrl.replace(/\/$/, '') + '/tagged/' + encodeURIComponent(tag),
        window.location.origin
      );

      if (page > 1) taggedUrl.searchParams.set('page', page);

      var response = await fetch(taggedUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Unable to load tagged blog posts.');

      var responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      var pageCards = Array.from(responseDocument.querySelectorAll('.main-blog__items > .f-column'));

      if (!pageCards.length) break;

      pageCards.forEach(function (card) {
        var articleLink = card.querySelector('a[href*="/blogs/"]');
        var articleKey = articleLink ? articleLink.pathname : card.textContent.trim();

        if (!seenArticles.has(articleKey)) {
          seenArticles.add(articleKey);
          cards.push(card);
        }
      });
    }

    return cards;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
